
import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Corporateresults.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { Modal } from "react-bootstrap";
import renderHTML from 'react-render-html';
import NewsOption from "../../NewsOption/NewsOption";
import { Vortex } from 'react-loader-spinner'
let companyInformation;
function Corporateresults() {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [data, setData] = useState([]);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);

    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;
    let optionNews = "Corporate Results";

    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "News";

        fetch(`${getUrl}/7/20/-/100`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                companyInformation = data.data;
                //console.log(data.data)
                setCompanyInfo(companyInformation);
                console.log("data", companyInformation);
                // console.log(getData, "getData")
                setloadingshow(false);
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    // const handleClosePopup = () => {
    //     setShow(false);
    // }
    // const newsModal = (e) => {

    //     const fetchId = e.currentTarget.getAttribute('data-id');
    //     let filteredCompanyInformation = companyInfo.filter(oneData => { return parseInt(oneData['Sno']) === parseInt(fetchId) })
    //     console.log(filteredCompanyInformation)

    //     setFilteredNewsData(filteredCompanyInformation)
    //     handleShow();
    // }

    const routeChange = (event) => {
        const fetchId = event.currentTarget.getAttribute('data-id');
        const fetchHead = event.currentTarget.getAttribute('data-head');
        window.open("/Detail-News/" + fetchId + "/" + fetchHead.replace(/ /g, '-').replace('&', 'and').replace('/', 'slash').replace('?', 'questionMark').replace('=', 'isEqualsTo').replace(':', 'colon').replace('%', 'Percent'), '_blank');
    };


    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Corporate Results</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='corprat-loser-sc'>
                            <div className='corprat-header'>
                                <h2><span>Corporate Results</span></h2>
                            </div>
                            <NewsOption optionNews={optionNews} />
                            <div className='corprat-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Date</th>
                                            <th className='text-left'>Time</th>
                                            <th className='text-left'>Heading</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ Date, Time, Heading, Sno }) => (
                                                <tr>
                                                    <td className="text-left"> {(Date != null) ? Date.split('T')[0] : 0}</td>
                                                    <td className="text-left"> {Time}</td>
                                                    <td className="newhead"><h6 onClick={routeChange}  data-head={Heading} data-id={Sno} tabIndex={0} >{Heading}</h6> </td>
                                                </tr>
                                            ))}
                                        {/* {currentTableData && currentTableData.map(
                                            ({ Date, Time, Heading, Arttext, Sno }) => (
                                                <tr>
                                                    <td className="text-left"> {(Date != null) ? Date.split('T')[0] : 0}</td>

                                                    <td className="text-left"> {Time}</td>
                                                    <td>
                                                        {<a data-id={Sno} onClick={newsModal}>

                                                            <a data-id={Sno} >
                                                                <td className="text-left">{Heading}</td>
                                                               
                                                            </a>
                                                        </a>
                                                        }
                                                    </td>
                                                </tr>
                                            ))}


                                        {filteredNewsData &&
                                            filteredNewsData.map(({ co_code, SNo, Heading, Date, Time, Arttext, memo }) => (
                                                <Modal show={show} className="modal company-snap-modal">

                                                    <Modal.Body id="modal_info">
                                                        <div className="titleCompany">{Heading}</div>
                                                        <div className="btnDiv">
                                                            <div className="btncl" onClick={handleClosePopup} > X </div>
                                                        </div>
                                                        <div className="infoCompany">{renderHTML(Arttext)}</div>
                                                    </Modal.Body>

                                                </Modal>
                                            ))} */}


                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer compNews"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Corporateresults;